// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.3";import { getIgnoredErrorsAndUrlsList, getSentryEnvironment } from '@/utils/sentry';
import * as Sentry from '@sentry/nextjs';

const ignoreList = getIgnoredErrorsAndUrlsList();

Sentry.init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
	environment: getSentryEnvironment(),
	tracesSampleRate: 0.05,
	debug: process.env.NODE_ENV === 'development',
	release: process.env.package_version,
	ignoreErrors: ignoreList.errors,
	denyUrls: ignoreList.urls,
	beforeSend(event) {
		event.tags = {
			...event.tags,
			locale: process.env.NEXT_PUBLIC_LANGUAGE,
		};
		return event;
	},
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
